import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import q from "../assets/q.png";
import "./Footer.css";

function IconInstagram() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7.5 3h9A4.5 4.5 0 0 1 21 7.5v9A4.5 4.5 0 0 1 16.5 21h-9A4.5 4.5 0 0 1 3 16.5v-9A4.5 4.5 0 0 1 7.5 3Zm0 1.7A2.8 2.8 0 0 0 4.7 7.5v9a2.8 2.8 0 0 0 2.8 2.8h9a2.8 2.8 0 0 0 2.8-2.8v-9a2.8 2.8 0 0 0-2.8-2.8h-9Zm9.85 1.35a1.05 1.05 0 1 1 0 2.1 1.05 1.05 0 0 1 0-2.1ZM12 7.6A4.4 4.4 0 1 1 7.6 12 4.4 4.4 0 0 1 12 7.6Zm0 1.7A2.7 2.7 0 1 0 14.7 12 2.7 2.7 0 0 0 12 9.3Z" />
    </svg>
  );
}

function IconFacebook() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M13.5 21v-7.2h2.4l.36-2.8H13.5V9.2c0-.8.22-1.35 1.38-1.35H16.4V5.35C16.05 5.3 15.1 5.2 14 5.2c-2.3 0-3.88 1.4-3.88 4v1.8H7.8v2.8h2.32V21h3.38Z" />
    </svg>
  );
}

function IconLinkedIn() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6.2 9.2H3.6V20.5h2.6V9.2ZM4.9 3.5a1.55 1.55 0 1 0 0 3.1 1.55 1.55 0 0 0 0-3.1ZM20.4 20.5h-2.6v-5.55c0-1.32-.47-2.22-1.65-2.22-.9 0-1.43.6-1.67 1.18-.09.2-.11.49-.11.78v5.81H11.8s.03-9.42 0-10.4h2.6v1.47c.35-.53 1.22-1.64 2.97-1.64 2.17 0 3.03 1.42 3.03 4.23V20.5Z" />
    </svg>
  );
}

export const Footer = ({ openForm, language }) => {
  const isArabic = language === "ar";
  const location = useLocation();
  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();

    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: targetId } });
      return;
    }

    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      const headerHeight = 80;
      const elementPosition = targetElement.offsetTop - headerHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    if (location.state?.scrollTo && location.pathname === "/") {
      const targetElement = document.querySelector(location.state.scrollTo);
      if (targetElement) {
        const headerHeight = 80;
        const elementPosition = targetElement.offsetTop - headerHeight;

        setTimeout(() => {
          window.scrollTo({
            top: elementPosition,
            behavior: "smooth",
          });
        }, 100);

        navigate("/", { replace: true, state: {} });
      }
    }
  }, [location, navigate]);

  const socialLinks = [
    {
      href: "https://www.instagram.com/qargoquote.qa/",
      label: isArabic ? "إنستغرام" : "Instagram",
      icon: <IconInstagram />,
    },
    {
      href: "https://www.facebook.com/profile.php?id=61582013609113",
      label: isArabic ? "فيسبوك" : "Facebook",
      icon: <IconFacebook />,
    },
    {
      href: "https://www.linkedin.com/company/qargoquote/",
      label: isArabic ? "لينكد إن" : "LinkedIn",
      icon: <IconLinkedIn />,
    },
  ];

  return (
    <footer
      className={`ft ${isArabic ? "ft--rtl" : ""}`}
      dir={isArabic ? "rtl" : "ltr"}
      lang={language}
    >
      <div className="ft__inner">
        <div className="ft__head">
          <div className="ft__brand">
            <Link to="/" className="ft__logo" onClick={goToHome}>
              <img src={q} alt="Qargoquote" />
            </Link>
            <p className="ft__tagline">
              {isArabic
                ? "منصة اللوجستيات بين الشركات في قطر."
                : "Qatar’s B2B logistics marketplace."}
            </p>
          </div>

          <button type="button" className="ft__email" onClick={openForm}>
            {isArabic ? "تواصل معنا" : "Contact support"}
          </button>
        </div>

        <div className="ft__grid">
          <div className="ft__col">
            <div className="ft__social">
              {socialLinks.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.label}
                  className="ft__social-link"
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="ft__col">
            <div className="ft__office-block">
              <h4 className="ft__col-title">
                {isArabic ? "مكتبنا" : "Office"}
              </h4>
              <p className="ft__office-text">
                {isArabic
                  ? "برج تورنادو، الطابق ٢٢، الخليج الغربي، الدوحة، قطر"
                  : "Tornado Tower, Floor 22, Westbay, Doha, Qatar"}
              </p>
            </div>
          </div>

          <nav className="ft__col" aria-label={isArabic ? "الحلول" : "Solutions"}>
            <h4 className="ft__col-title">{isArabic ? "الحلول" : "Solutions"}</h4>
            <ul className="ft__list">
              <li>
                <button type="button" onClick={() => navigate("/service-provider")}>
                  {isArabic ? "مقدمو الخدمات" : "Service providers"}
                </button>
              </li>
              <li>
                <button type="button" onClick={() => navigate("/importer")}>
                  {isArabic ? "المستوردون والتجار" : "Importers & traders"}
                </button>
              </li>
              <li>
                <Link to="/SOP">SOP</Link>
              </li>
            </ul>
          </nav>

          <nav className="ft__col" aria-label={isArabic ? "المنصة" : "Platform"}>
            <h4 className="ft__col-title">{isArabic ? "المنصة" : "Platform"}</h4>
            <ul className="ft__list">
              <li>
                <button type="button" onClick={(e) => handleSmoothScroll(e, "#FAQ")}>
                  FAQ
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={(e) => handleSmoothScroll(e, "#subscription")}
                >
                  {isArabic ? "الاشتراك" : "Subscription"}
                </button>
              </li>
              <li>
                <a
                  href="https://qatar.qargoquote.com/login"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {isArabic ? "تسجيل الدخول" : "Login"}
                </a>
              </li>
              <li>
                <a
                  href="https://qatar.qargoquote.com/signUp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {isArabic ? "انضم إلينا" : "Join Us"}
                </a>
              </li>
            </ul>
          </nav>

          <nav className="ft__col" aria-label={isArabic ? "الشركة" : "Company"}>
            <h4 className="ft__col-title">{isArabic ? "الشركة" : "Company"}</h4>
            <ul className="ft__list">
              <li>
                <button type="button" onClick={goToHome}>
                  {isArabic ? "الرئيسية" : "Home"}
                </button>
              </li>
              <li>
                <button type="button" onClick={openForm}>
                  {isArabic ? "اتصل بنا" : "Contact us"}
                </button>
              </li>
              <li>
                <Link to="/privacy-policy">
                  {isArabic ? "سياسة الخصوصية" : "Privacy Policy"}
                </Link>
              </li>
              <li>
                <Link to="/career">{isArabic ? "توظيف" : "Career"}</Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="ft__bottom">
          <p className="ft__copy">
            © {new Date().getFullYear()} Qargoquote™ —{" "}
            {isArabic ? "جميع الحقوق محفوظة" : "All Rights Reserved"}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
